import { Edit, More } from "@rsuite/icons";
import React, { useEffect, useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewCustomerModal from "./ViewCustomer";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { isWebResolutionSize } from "../../../utils/helpers";

const CustomerFinderSingleAction = ({
  customerData,
  permission,
  ...props
}: {
  customerData: any;
  permission: any;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [isWebResolution, setIsWebResolution] = useState(isWebResolutionSize());
  const ecryptedCustomerId = encryptUrl(`${customerData.id}`);

  const customerUpdateLink = ContentRoutes.UPDATE_CUSTOMER.replace(
    ":id",
    ecryptedCustomerId.toString()
  );

  const navigate = useNavigate();
  const updateResolution = () => {
    setIsWebResolution(isWebResolutionSize());
  };

  useEffect(() => {
    window.addEventListener("resize", updateResolution);
  }, []);

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      const validPopupActions = ["view-customer"];
      if (eventKey == "edit-customer") {
        handleEditAction();
      } else if (validPopupActions.includes(eventKey.toLocaleLowerCase())) {
        setOpenModalByName(eventKey);
        dispatch(setActionData(customerData));
      }
      onClose();
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-customer"}>
            {t("VIEW")} {t("CUSTOMER")}
          </Dropdown.Item>
          {!isWebResolution && (
            <>
              {permission.update && (
                <Dropdown.Item eventKey={"edit-customer"}>
                  {t("EDIT")} {t("CUSTOMER")}
                </Dropdown.Item>
              )}
            </>
          )}
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${customerUpdateLink}`);
  }

  return (
    <div>
      {isWebResolution && (
        <>
          {permission.update && (
            <>
              <IconButton
                appearance="subtle"
                as="a"
                href={customerUpdateLink}
                target="_blank"
                rel="noopener noreferrer"
                title={t("EDIT")}
                icon={<Edit />}
              />
            </>
          )}
        </>
      )}

      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-customer" && (
        <ViewCustomerModal
          status={openModalByName === "view-customer" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
    </div>
  );
};

export default CustomerFinderSingleAction;
